import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.assays'),
    id: 'laboratoryAssays',
    sidebar: [
        {
            id: 'assay-groups',
            label: i18n.tc('configuration.sections.assayGroup', 2),
            icon: 'far fa-th-large',
            routeName: 'LocalAssayGroups',
            hasChildren: false
        },
        {
            id: 'assays',
            label: i18n.tc('configuration.sections.assay', 2),
            icon: 'fas fa-flask',
            routeName: 'LocalAssays',
            hasChildren: false
        },
        {
            id: 'assay-results',
            label: i18n.tc('configuration.sections.assayResult', 2),
            icon: 'fal fa-tasks-alt',
            routeName: 'LocalAssayResults',
            hasChildren: false
        },
        {
            id: 'protocols',
            label: i18n.tc('configuration.sections.protocol', 2),
            icon: 'fal fa-sitemap',
            routeName: 'LocalAssayProtocol',
            hasChildren: false
        }
    ]
}
